import { Modal } from "react-bootstrap"
import ButtonClose from "./ButtonClose"
import './modal.css'

const ModalRobo = (props) => {

    const handleClose = () => props.close(false)

    return (
        <>
            <Modal show={props.show} onHide={handleClose} size="xl" centered>
                <Modal.Body>
                    <ButtonClose close={handleClose} />
                    <div className='modal__groups pb-5'>
                        <div className="modal__group" style={{ borderColor: 'var(--azul)' }}>
                            <div className="cob__card-ico_container-mov-modal">
                                <img style={{width:'45px'}} src='/assets/img/homeout/robo/ico-robo.png' alt="imagen cob icono" />
                            </div>
                            <div className="modal__descripcion">
                            <h1 className="color_morado_light my-5">Daño accidental</h1>
                                <p>En caso de sufrir robo con violencia reemplazaremos el equipo por uno de características similares nuevo o re-acondicionado hasta por una (1) vez al año. Para conocer más sobre los términos y condiciones de esta cobertura consulta las condiciones generales y tu certificado de cobertura.</p>
                            </div>
                        <div className="modal__descripcion">
                                <h3>¿En qué casos no te protege tu seguro?</h3>
                                <ul className="list__modal" style={{'color':'black'}}>
                                    <li className="d-flex">Hurto o pérdida del equipo, auto-robo, robo ocurrido durante actos de alboroto popular, robo ocurrido durante el proceso de entrega en compras online, robo de equipos cuyo IMEI no esté autorizado para darse de baja.</li>
                                </ul>
                            </div>
                        </div> 
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ModalRobo